<template>
  <div v-if="loaded" class="top-up-page">
    <AppHero :heading="'How many credits would you like?'">
      <p class="body-copy body-copy--align-center">
        We’ll add these to your current credit pot.
      </p>
    </AppHero>
    <!-- 
    <h2>Current Balance: {{ currentBalance }} Credits</h2>
    <button @click="addCredits" class="btn">Add 100 credits</button>
    <button @click="removeAllCredits" class="btn">Remove All Credits</button> -->

    <section class="top-up">
      <div class="container container--mw-xxxl">
        <AppTabs>
          <AppTab title="Pay As You Go">
            <ProductBlock
              :title="'Khonsu Single Session'"
              :description="'5 searches'"
              :price="'£5'"
            >
              <stripe-checkout
                ref="checkoutRef_single"
                mode="payment"
                :pk="publishableKey"
                :line-items="[
                  { price: khonsu_singleSessionpriceId, quantity: 1 },
                ]"
                :success-url="success_url[0].khonsu_singleSession"
                :cancel-url="cancel_url[0].khonsu_singleSession"
                @loading="(v) => (loading = v)"
                :session-id="
                  this.$store.state.Payment.khonsu_singleSession_sessionid
                "
              />
              <button @click="submit_khonsu_single_session" class="btn blue">
                Buy now!
              </button>
            </ProductBlock>

            <ProductBlock
              :title="'Khonsu Light'"
              :description="'15 searches'"
              :price="'£10'"
            >
              <stripe-checkout
                ref="checkoutRef_light"
                mode="payment"
                :pk="publishableKey"
                :line-items="[{ price: khonsu_lightpriceId, quantity: 1 }]"
                :success-url="success_url[1].khonsu_light"
                :cancel-url="cancel_url[1].khonsu_light"
                @loading="(v) => (loading = v)"
                :session-id="this.$store.state.Payment.khonsu_light_sessionid"
              />
              <button @click="submit_khonsu_light_session" class="btn blue">
                Buy now!
              </button>
            </ProductBlock>

            <ProductBlock
              :title="'Khonsu Unlimited'"
              :description="'Unlimited searches'"
              :price="'£50'"
            >
              <stripe-checkout
                ref="checkoutRef_unlimited"
                mode="payment"
                :pk="publishableKey"
                :line-items="[{ price: khonsu_unlimitedpriceId, quantity: 1 }]"
                :success-url="success_url[2].khonsu_unlimited"
                :cancel-url="cancel_url[2].khonsu_unlimited"
                @loading="(v) => (loading = v)"
                :session-id="
                  this.$store.state.Payment.khonsu_unlimited_sessionid
                "
              />
              <input
                v-model="couponCode"
                type="text"
                placeholder="Enter coupon code"
                class="couponCode"
              />
              <button @click="submit_khonsu_unlimited_session" class="btn blue">
                Buy now!
              </button>
              <div class="couponMessages">
                <p
                  v-if="invalidCoupon"
                  class="error-message"
                  ref="invalidCouponMessage"
                >
                  Invalid coupon code.
                </p>
                <p
                  v-if="couponAlreadyUsed"
                  class="error-message"
                  ref="couponAlreadyUsedMessage"
                >
                  This coupon code has already been used.
                </p>
              </div>
            </ProductBlock>
          </AppTab>
        </AppTabs>
      </div>
    </section>
  </div>
  <div v-else class="spinner-container">
    <div class="spinner"></div>
  </div>
</template>

<style lang="scss">
.error-message {
  color: red;
  margin-top: 20px;
  font-size: 18px;
}

.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 4px solid $mainColor;
  border-top: 4px solid black;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.couponCode {
  width: 50%;
  padding: 8px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  background-color: #ffffff;
  box-sizing: border-box;
  margin-right: 8px;
}

@media (max-width: 991px) {
  .couponCode {
    width: 100%;
    margin-bottom: 16px;
    margin-right: 0;
  }
}

@media (max-width: 768px) {
  .couponCode {
    width: 100%;
    margin-right: 0;
    margin-bottom: 16px;
  }
}
</style>

<script>
import AppHero from "@/components/layout/AppHero";
import AppTabs from "@/components/ui/AppTabs";
import AppTab from "@/components/ui/AppTab";
import ProductBlock from "@/views/ChangePlan/ProductBlock";
import { StripeCheckout } from "@vue-stripe/vue-stripe";
import axios from "axios";

export default {
  name: "TopUpPage",
  metaInfo: {
    title: "Khonsu - TopUpPage",
  },
  components: {
    AppHero,
    AppTabs,
    AppTab,
    ProductBlock,
    StripeCheckout,
  },
  computed: {},
  data() {
    return {
      invalidCoupon: false,
      couponAlreadyUsed: false,
      khonsu_singleSessionpriceId:
        process.env.VUE_APP_KHONSU_SINGLE_SESSION_PRICEID,
      khonsu_lightpriceId: process.env.VUE_APP_KHONSU_LIGHT_PRICEID,
      khonsu_unlimitedpriceId: process.env.VUE_APP_KHONSU_UNLIMITED_PRICEID,
      success_url: [
        {
          khonsu_singleSession:
            process.env.VUE_APP_ROOT_URL +
            "/payment-success/10/" +
            this.$store.state.Payment.khonsu_single_sessionid,
        },
        {
          khonsu_light:
            process.env.VUE_APP_ROOT_URL +
            "/payment-success/20/" +
            this.$store.state.Payment.khonsu_light_sessionid,
        },
        {
          khonsu_unlimited:
            process.env.VUE_APP_ROOT_URL +
            "/payment-success/50/" +
            this.$store.state.Payment.khonsu_unlimited_sessionid,
        },
      ],
      cancel_url: [
        {
          khonsu_singleSession:
            process.env.VUE_APP_ROOT_URL +
            "/payment-failure/10/" +
            this.$store.state.Payment.khonsu_light_sessionid,
        },
        {
          khonsu_light:
            process.env.VUE_APP_ROOT_URL +
            "/payment-failure/20/" +
            this.$store.state.Payment.khonsu_light_sessionid,
        },
        {
          khonsu_unlimited:
            process.env.VUE_APP_ROOT_URL +
            "/payment-failure/50/" +
            this.$store.state.Payment.khonsu_light_sessionid,
        },
      ],
      publishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
      ciaranKey: process.env.VUE_APP_STRIPE_CIARAN_KEY,
      loading: false,
      loaded: false,
      couponCode: "",
      currentBalance: 0,
    };
  },
  methods: {
    submit_khonsu_single_session() {
      this.$refs.checkoutRef_single.redirectToCheckout();
    },
    submit_khonsu_light_session() {
      this.$refs.checkoutRef_light.redirectToCheckout();
    },
    submit_khonsu_unlimited_session() {
      if (this.couponCode === "") {
        this.$refs.checkoutRef_unlimited.redirectToCheckout();
      } else if (this.couponCode !== process.env.VUE_APP_COUPON_CODE) {
        this.invalidCoupon = true;
        setTimeout(() => {
          this.invalidCoupon = false;
        }, 4000);
      } else {
        // console.log("Coupon valid");
        this.addCouponCredits((success) => {
          if (success) {
            this.$router.push("/thank-you");
          }
        });
      }
    },

    // addCredits() {
    //   const creditsToAdd = 100;
    //   axios({
    //     method: "post",
    //     url: "http://localhost/api/addCredits",
    //     data: {
    //       userId: sessionStorage.getItem("user_id"),
    //       credits: creditsToAdd,
    //     },
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //   })
    //     .then((response) => {
    //       this.currentBalance += response.data.credits;
    //     })
    //     .catch((error) => {
    //       console.error(error);
    //     });
    // },

    addCouponCredits(callback) {
      const creditsToAdd = 999;
      axios({
        method: "post",
        url: `${process.env.VUE_APP_API_ROOT_URL}/api/addCouponCredits`,
        data: {
          userId: sessionStorage.getItem("user_id"),
          credits: creditsToAdd,
        },
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.data.error) {
            alert(response.data.error);
            callback(false);
            return;
          }
          this.currentBalance += creditsToAdd;
          callback(true);
        })
        .catch((error) => {
          console.error(error);
          this.couponAlreadyUsed = true;
          setTimeout(() => {
            this.couponAlreadyUsed = false;
          }, 4000);
          callback(false);
        });
    },

    getCredits() {
      axios({
        method: "post",
        url: `${process.env.VUE_APP_API_ROOT_URL}/api/getCredits`,
        data: {
          userId: sessionStorage.getItem("user_id"),
        },
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          this.currentBalance = response.data.credits;
          // console.log("current balance fetched:", this.currentBalance);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    removeAllCredits() {
      axios({
        method: "post",
        url: `${process.env.VUE_APP_API_ROOT_URL}/api/removeAllCredits`,
        data: {
          userId: sessionStorage.getItem("user_id"),
        },
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          this.currentBalance = response.data.credits;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },

  async mounted() {
    try {
      await Promise.all([
        this.$store.dispatch("Payment/getkhonsu_singleSession_sessionid", {
          priceid: process.env.VUE_APP_KHONSU_SINGLE_SESSION_PRICEID,
          userid: sessionStorage.getItem("user_id"),
          productname: "Khonsu Single Session",
          productid: process.env.VUE_APP_KHONSU_SINGLE_SESSION_PRODUCTID,
          customer_email: sessionStorage.getItem("_khonsu_user_email"),
          success_url: "10/",
          cancel_url: "10/",
        }),

        this.$store.dispatch("Payment/getkhonsu_light_sessionid", {
          priceid: process.env.VUE_APP_KHONSU_LIGHT_PRICEID,
          userid: sessionStorage.getItem("user_id"),
          productname: "Khonsu Light",
          productid: process.env.VUE_APP_KHONSU_LIGHT_PRODUCTID,
          customer_email: sessionStorage.getItem("_khonsu_user_email"),
          success_url: "20/",
          cancel_url: "20/",
        }),

        this.$store.dispatch("Payment/getkhonsu_unlimited_sessionid", {
          priceid: process.env.VUE_APP_KHONSU_UNLIMITED_PRICEID,
          userid: sessionStorage.getItem("user_id"),
          productname: "Khonsu Unlimited",
          productid: process.env.VUE_APP_KHONSU_UNLIMITED_PRODUCTID,
          customer_email: sessionStorage.getItem("_khonsu_user_email"),
          success_url: "50/",
          cancel_url: "50/",
        }),
      ]);
      this.getCredits(); // Fetch the current credits
    } catch (e) {
      console.error(e);
    } finally {
      this.loaded = true;
    }
  },
};
</script>
